import styled from "styled-components";

import { BaseButton } from "uikit/Button/styles";

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.colorsNew.primary["50"]};
  padding: ${({ theme }) => theme.padding.p10};
  border-bottom: 1px solid ${({ theme }) => theme.colors.colorsNew.primary["200"]};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ManageSubscriptionButtonContainer = styled.div`
  ${BaseButton} {
    color: ${({ theme }) => theme.colors.colorsNew.primary["500_main"]};

    &:hover {
      color: ${({ theme }) => theme.colors.colorsNew.primary[400]};
    }

    &:active {
      color: ${({ theme }) => theme.colors.colorsNew.primary[600]};
    }

    &:disabled {
      color: ${({ theme }) => theme.colors.colorsNew.gray[400]};
    }
  }
`;
